module.exports = __webpack_public_path__ + "static/media/BgSearch.0aff1377.png";